// Настройките за средата се четат при зареждане на страницата от /config.js,
// който всеки overlay в kustomize монтира в контейнера. Така един и същ образ
// се ползва във всички среди. При разработка (yarn dev) config.js е празен и
// стойностите идват от .env файловете.

export type AppConfig = {
  apiBase: string;
  wsAddress: string;
  recommendationsApiBase: string;
  authServer: string;
  authClientId: string;
  authClientSecret: string;
  globalMessage?: string;
  deploymentTitle: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

const runtimeConfig = window.__APP_CONFIG__ || {};

export const config: AppConfig = {
  apiBase: runtimeConfig.apiBase ?? import.meta.env.VITE_API_BASE,
  wsAddress: runtimeConfig.wsAddress ?? import.meta.env.VITE_WS_ADDRESS,
  recommendationsApiBase:
    runtimeConfig.recommendationsApiBase ??
    import.meta.env.VITE_RECOMMENDATIONS_API_BASE,
  authServer: runtimeConfig.authServer ?? import.meta.env.VITE_AUTH_SERVER,
  authClientId:
    runtimeConfig.authClientId ?? import.meta.env.VITE_AUTH_CLIENT_ID,
  authClientSecret:
    runtimeConfig.authClientSecret ?? import.meta.env.VITE_AUTH_CLIENT_SECRET,
  globalMessage:
    runtimeConfig.globalMessage ?? import.meta.env.VITE_GLOBAL_MESSAGE,
  deploymentTitle:
    runtimeConfig.deploymentTitle ??
    import.meta.env.VITE_DEPLOYMENT_TITLE ??
    "Наряд - Автотранспорт",
};

// Не зависи от средата - адрес, за който createBaseQuery връща празен отговор
// без да прави заявка
export const EMPTY_API_URI = "/EMPTY_API_URI/";
